import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsSystemEventsDeleteRoute: InvariantJiraRoute = {
	name: 'global-settings-system-events-delete',
	path: '/secure/admin/DeleteEventType.jspa',
};
